export const EmissionOptions = [
  {
    name: 'Carbonmonoxide',
    description: 'carbbon monoxide [mol/m²]'
  },
  {
    name: 'Ozone',
    description: 'ozone [mol/m²]'
  },
  {
    name: 'Nitrogendioxide',
    descriptin: 'tropospheric column (spatial resolution 7x3.5km2) '
  },
  {
    name: 'Methane',
    description: 'tropospheric column (spatial resolution 7x7km2) '
  }
]
